"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var LeftArrow2Outlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M692.352 120.043a42.667 42.667 0 00-57.515-4.139l-2.773 2.41-367.595 347.009a64 64 0 00-2.602 90.453l2.581 2.603 367.573 347.306a42.667 42.667 0 0061.184-59.392l-2.56-2.645-351.168-331.797 351.147-331.499a42.667 42.667 0 004.139-57.515l-2.411-2.773z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
LeftArrow2Outlined.displayName = "LeftArrow2Outlined";
var _default = exports["default"] = LeftArrow2Outlined;